import React, { useState } from 'react'
import SearchFilter from '../../common/search-filter'
import useUsersFilters from '../../../hooks/use-users-filters'
import useDebouncedCallback from '../../../hooks/use-debounced-callback'

const UsersSearchStringFilter = ({
    value = '',
    disabled
}) => {
    const { setSearchString } = useUsersFilters()
    const [ search, setSearch ] = useState(value)

    useDebouncedCallback({
        value: search,
        callback: setSearchString
    })

    return (
        <SearchFilter
            title='What are you looking for?'
            value={search || ''}
            onChange={setSearch}
            disabled={disabled}
            size='lg'
        />
    )
}

export default UsersSearchStringFilter